import StorageService from '../../services/StorageService';

export default function appStorage() {
  return new StorageService();
}
